export const CONTACT_BOOKING_REQ = "CONTACT_BOOKING_REQ";
export const CONTACT_BOOKING_SUCCESS = "CONTACT_BOOKING_SUCCESS";
export const CONTACT_BOOKING_FAILED = "CONTACT_BOOKING_FAILED";
export const CONTACT_BOOKING_RESET = "CONTACT_BOOKING_RESET";

export const TEST_BOOKING_REQ = "TEST_BOOKING_REQ";
export const TEST_BOOKING_SUCCESS = "TEST_BOOKING_SUCCESS";
export const TEST_BOOKING_FAILED = "TEST_BOOKING_FAILED";
export const TEST_BOOKING_RESET = "TEST_BOOKING_RESET";
